module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-02.a8935724.png";